import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { format } from 'date-fns';
import { HosDaily } from 'src/components/HosDaily/HosDaily';
import { getHosDaily, getHosLogTimeZone } from '../store';
import { useRouteMatch } from 'react-router-dom';

export const HosDailyTab: React.FC = () => {
  const routeMatch = useRouteMatch<{ date: string }>();
  const dateParam = routeMatch.params.date;

  const hosDaily = useSelector(getHosDaily);
  const timeZone = useSelector(getHosLogTimeZone) || 'America/Chicago';
  const dateObj = useMemo(() => moment(dateParam).toDate(), [dateParam]);
  const hosDailyDate = useMemo(() => format(dateObj, 'MMM dd, yyyy'), [dateObj]);

  return <HosDaily hosDaily={hosDaily} recordDate={hosDailyDate} timeZone={timeZone} />;
};
